import {
  FaLinkedinIn,
  FaInstagram,
  FaGithub,
  FaBehance,
  FaYoutube,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import { FaHashnode } from "react-icons/fa6";
import "../Css/Components/Footer.css";
const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="footer-logo">
          <a href="/" aria-label="Ana sayfaya git">
            <img src="/assets/images/home/v-logo.webp" alt="" />
          </a>
        </div>
        <div className="footer-contact">
          <strong>E-Mail</strong>
          <a href="mailto:volkankiycakofficial@gmail.com">
            volkankiycakofficial@gmail.com
          </a>
        </div>
        <div className="footer-social">
          <div>
            <a
              href="https://www.linkedin.com/in/volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn profilime git"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://github.com/volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub profilime git"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.behance.net/volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn profilime git"
            >
              <FaBehance />
            </a>
            <a
              href="https://hashnode.com/@volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram hesabımı gör"
            >
              <FaHashnode />
            </a>
          </div>
          <div>
            <a
              href="https://www.instagram.com/kiycakofficial/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram hesabımı gör"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.instagram.com/kiycakofficial/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Kariyer.net özgeçmişimi gör"
            >
              <FaFacebook />
            </a>
            <a
              href="https://x.com/volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub profilime git"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.youtube.com/@volkankiycak"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Kariyer.net özgeçmişimi gör"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-menu-container">
        <div className="footer-menu">
          <a href="/About">Hakkımda</a>
          <a href="/Portfolio">Çalışmalarım</a>
          <a href="/Certificates">Sertifikalarım</a>
          <a href="/Blog">Blog</a>
          <a href="/Communication">İletişim</a>
        </div>
      </div>
      <div className="footer-policy-container">
        <div className="footer-policy">
          <a
            href="https://apps.microsoft.com/detail/9n0m8kcdc0ms?referrer=appbadge&cid=Website&mode=direct"
            title="Volkan Kıyçak"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://get.microsoft.com/images/tr%20dark.svg"
              width="180"
              alt="Microsoft Store'dan Volkan Kıyçak uygulaması"
            />
          </a>
          <a
            href="https://apps.microsoft.com/detail/9n0m8kcdc0ms?referrer=appbadge&cid=Website&mode=direct"
            title="Volkan Kıyçak"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/home/AppStoreLogo.webp"
              height="43"
              width="180"
              alt="Apple App Store'dan Volkan Kıyçak uygulaması"
            />
          </a>
          <a
            href="https://apps.microsoft.com/detail/9n0m8kcdc0ms?referrer=appbadge&cid=Website&mode=direct"
            title="Volkan Kıyçak"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/assets/images/home/GooglePlayStoreLogo.webp"
              height="43"
              width="180"
              alt="Google Play Store'dan Volkan Kıyçak uygulaması"
            />
          </a>
        </div>
        <div className="footer-copyright">
          <p>© 2026 www.volkankiycak.com, Tüm hakları saklıdır.</p>
        </div>
      </div>
    </div>
  );
};
export default Footer;
